import { css, cx, useTheme } from '@fable/theme'
import { BookDetailDescription } from '../sections'
import { BookDetailValuePropsV2 } from './value_props'
import { Book } from '@fable/types'

export const BookDetailAboutSectionV2 = ({
  book,
  hideProps,
}: {
  book: Book
  hideProps: boolean
}) => {
  const { colors } = useTheme()

  return (
    <>
      <div
        /**
         * @note
         * In the design spec, the section below (BookDetailDescription) does not have an anchor link
         * but it's design is identical to every section that does have a link
         * In order to use react-scroll's Link component's built-in behavior to prevent
         * back navigation issues, I had to manually add these styles to it can still look
         * like a section while being under the "About" section
         */
        className={cx(
          !hideProps
            ? css`
                margin-bottom: 34px;
                padding-bottom: 34px;
                border-bottom: 1px solid ${colors.whiteSmoke};
              `
            : ''
        )}
      >
        <BookDetailDescription book={book} />
      </div>
      {hideProps ? null : <BookDetailValuePropsV2 book={book} />}
    </>
  )
}
